import moment from 'moment';

export function isLastTwoWeeksLesson(datetime: Date) {
  return moment().diff(moment(datetime), 'weeks') >= -2;
}

export function isFinishedKlass(datetime: Date) {
  return moment(datetime).isBefore(moment());
}
